<template>
  <div class="w-full flex flex-col">
    <div class="">
      <div class="mb-4 font-bold text-xl">انتخاب بسته</div>
      <div class="text-center laptop:text-right">
        مشتری گرامی، لطفا نوع بسته مرکز تلفن ابری نواتل خود را انتخاب کنید.
      </div>
    </div>

    <div
      class="text-xl laptop:text-2xl font-bold text-center mt-10 laptop:mb-10"
    >
      {{
        shoppingType === "callcenter"
          ? "مرکز تلفن ابری نواتل"
          : "مرکز تماس ابری نواتل"
      }}
    </div>
    <div class="mb-10 flex flex-col laptop:flex-row justify-between gap-4">
      <div
        class="w-full mt-12 laptop:mt-0 p-4 custom-shadow bg-white relative rounded-xl"
        v-for="item in bundles"
        :key="'b' + item.id"
      >
        <ProductPlan :item="item" isSmall>
          <template #buttons>
            <div class="w-full">
              <BaseButton
                id="oshop-selectBundle"
                isLean
                size="full"
                :text="bundleId == item.id ? 'حذف بسته' : 'انتخاب بسته'"
                @click="itemSelected('BundleId', item)"
                :classes="bundleId == item.id ? '!bg-blue-700' : ''"
                :isDisabled="disableBundle(item)"
              />
            </div>
          </template>
        </ProductPlan>
      </div>
    </div>

    <div v-if="shoppingType === 'callcenter'">
      <div
        class="text-xl laptop:text-2xl font-bold text-center mt-10 laptop:mb-10"
      >
        سرویس فکس ابری نواتل بر روی مرکز تلفن
      </div>
      <div
        class="mb-10 tablet:grid tablet:grid-cols-2 laptop:flex justify-between gap-4"
      >
        <div
          class="w-full laptop:w-[25%] mt-12 laptop:mt-0 p-4 custom-shadow bg-white relative rounded-xl"
          v-for="item in faxes"
          :key="'f' + item.id"
        >
          <ProductPlan :item="item">
            <template #buttons>
              <div class="w-full mt-4">
                <BaseButton
                  id="oshop-selectBundle"
                  isLean
                  size="full"
                  :text="faxBundleId == item.id ? 'حذف بسته' : 'انتخاب بسته'"
                  @click="itemSelected('FaxBundleId', item)"
                  :classes="faxBundleId == item.id ? '!bg-blue-700' : ''"
                  :isDisabled="disableFax(item)"
                />
              </div>
            </template>
          </ProductPlan>
        </div>
      </div>

      <div class="text-xl laptop:text-2xl font-bold text-center mb-10">
        حجم فضای ابری
      </div>
      <div
        class="grid grid-cols-1 tablet:grid-cols-2 laptop:grid-cols-4 justify-between gap-4"
      >
        <div
          class="w-full p-4 custom-shadow relative bg-white mb-10 rounded-xl"
          v-for="item in qoutes"
          :key="'q' + item.id"
        >
          <ProductPlan :item="item">
            <template #buttons>
              <div class="w-full mt-4">
                <BaseButton
                  id="oshop-selectBundle"
                  isLean
                  size="full"
                  :text="cloudVolumeId == item.id ? 'حذف' : 'انتخاب'"
                  @click="itemSelected('CloudVolumeId', item)"
                  :classes="cloudVolumeId == item.id ? '!bg-blue-700' : ''"
                  :isDisabled="disableQoute"
                />
              </div>
            </template>
          </ProductPlan>
        </div>
      </div>
      <SectionShoppingElementAdditionalService />
    </div>

    <div
      v-if="errorMessage"
      class="text-red-500 text-xs text-start font-bold mt-6"
      v-text="errorMessage"
    />

    <div
      class="flex justify-between mt-10 flex-col laptop:flex-row [&>*]:laptop:w-[45%] [&>*]:mb-4 [&>*]:laptop:mb-0"
    >
      <div class="w-full laptop:max-w-[20%]">
        <BaseButton
          styleType="secondary"
          isLean
          size="full"
          text="بازگشت به مرحله قبل"
          @click="goToPrevStep"
        >
          <IconArrowLeft class="ml-2 rotate-180 my-auto" />
        </BaseButton>
      </div>
      <div class="w-full laptop:max-w-[20%]">
        <BaseButton
          isLean
          size="full"
          text="تایید و ادامه"
          @click="acceptClicked"
          id="oshop-selectNumber"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  shoppingType: String,
});

const { getBundles, getFaxBundles, getCloudVolumes, setNumber } =
  useOnlineShopping();

const emit = defineEmits(["goToNextStep", "goToPrevStep"]);
const bundleId = useState("BundleId") || null;
const faxBundleId = useState("FaxBundleId") || null;
const cloudVolumeId = useState("CloudVolumeId") || null;
const isCrm = useState("IsCrm") || null;
const isWebChat = useState("IsWebChat") || null;
const selectedNumberType = useState("selectedNumberType") || "";

const disableFax = (item) => {
  if (bundleId.value) {
    let bundle = bundles.value.find((el) => el.id == bundleId.value);
    return item.label == bundle?.label ? false : true;
  } else {
    return false;
  }
};

const disableBundle = (item) => {
  if (faxBundleId.value) {
    let fax = faxes.value.find((el) => el.id == faxBundleId.value);
    return item.label == fax?.label ? false : true;
    // } else if (item.label === "بسته تنگستن" || item.label === "بسته بيسموت") {
    //   return true;
  } else {
    return false;
  }
};

const disableQoute = computed(() => {
  return bundleId.value != 5 ? false : true;
});

const itemSelected = (item, data) => {
  if (useState(item).value == data.id) {
    useState(item).value = null;
    if (item == "BundleId") {
      useState("BundleName").value = null;
    }
  } else {
    useState(item).value = data.id;
    if (item == "BundleId") {
      useState("BundleName").value = data.label;
    }
  }
  if (item == "BundleId") {
    errorMessage.value = "";
    if (data.label == "تلفن ثابت اینترنتی") {
      useState("ChannelQuantity").value = 1;
      cloudVolumeId.value = null;
      isCrm.value = false;
    }
  }
};

const goToPrevStep = () => {
  emit("goToPrevStep");
};

onBeforeMount(async () => {
  const { data, error } = await getBundles({
    body: {
      Campaign: "OnlineSell",
      BundleId: "",
      type:
        props.shoppingType == "contactcenter"
          ? "contactcenter"
          : selectedNumberType.value == "8280"
          ? "8280"
          : props.shoppingType,
    },
  });
  if (!error.value && data.value) {
    bundles.value = toRaw(data.value)
      .filter((el) => el.isActive)
      .map((el) => {
        let price = +el.bundleDetails[0].price.replaceAll("/", "");
        let setupFee = +el.bundleDetails[0].setupFee.replaceAll("/", "");
        return {
          id: el.id,
          title: "سالیانه",
          label: el.title,
          order: el.ordering,
          isRecomended: el.isRecommend,
          price,
          setupFee,
          options: el.bundleFeatures.map((feature) => {
            return {
              id: feature.id,
              title: feature.description,
              order: feature.ordering,
            };
          }),
          off: el.campaigns.length ? el.campaigns[0].discount : null,
        };
      });
  }

  const { data: faxData, error: faxError } = await getFaxBundles({
    body: {
      type: selectedNumberType.value == "8280" ? "8280" : "9169",
    },
  });
  if (!faxError.value && faxData.value) {
    faxes.value = toRaw(faxData.value)
      .filter((el) => el.isActive)
      .map((el) => {
        let price = +el.faxBundleDetails[0].price.replaceAll("/", "");
        return {
          id: el.id,
          title: "سالیانه",
          label: el.title,
          order: el.ordering,
          isRecomended: el.isRecommend,
          price,
          options: el.faxBundleFeatures.map((feature) => {
            return {
              id: feature.id,
              title: feature.description,
              order: feature.ordering,
            };
          }),
          off: el.faxCampaigns.length ? el.faxCampaigns[0].discount : null,
        };
      });
  }

  const { data: cloudVolumesData, error: cloudVolumesError } =
    await getCloudVolumes();
  if (!cloudVolumesError.value && cloudVolumesData.value) {
    let items = toRaw(cloudVolumesData.value)[0];
    let off = items.calculatedServicesCampaigns.length
      ? items.calculatedServicesCampaigns[0].discount
      : null;
    qoutes.value = items.calculatedDetails.map((el) => {
      return {
        id: el.id,
        label: el.title.replace("Gb", "گیگابایتی"),
        price: el.price,
        off: off,
      };
    });
  }
});

const bundles = ref([]);
const faxes = ref([]);
const qoutes = ref([]);
const items = ref([]);

const errorMessage = ref("");

const acceptClicked = async () => {
  if (!bundleId.value) {
    errorMessage.value = "اتخاب بسته الزامی است.";
  } else {
    const shoppingData = JSON.parse(localStorage.getItem(props.shoppingType));

    shoppingData.InitialCredit = useState("InitialCredit").value;
    shoppingData.ChannelQuantity = useState("ChannelQuantity").value;
    shoppingData.didNo = useState("didNo").value;
    shoppingData.selectDidNoColor = useState("selectDidNoColor").value;
    shoppingData.selectDidNo = useState("selectDidNo").value;
    shoppingData.BundleId = useState("BundleId").value;
    shoppingData.FaxBundleId = useState("FaxBundleId").value;
    shoppingData.CloudVolumeId = useState("CloudVolumeId").value;
    shoppingData.IsCrm = useState("IsCrm").value || false;
    shoppingData.SelectedCrmId = useState("SelectedCrmId").value || "";
    shoppingData.IsWebChat = useState("IsWebChat").value || false;
    shoppingData.selectedNumberType = useState("selectedNumberType").value;
    localStorage.setItem(props.shoppingType, JSON.stringify(shoppingData));

    const { data, error } = await setNumber();
    if (!error.value && data.value) {
      emit("goToNextStep");
    }
  }
};

const { formatPrice } = useInputHelpers();
const getOffPrice = (price, off) => {
  const totalPrice = (price * off) / 100;
  const offPrice = formatPrice(price - totalPrice);
  return offPrice;
};
</script>
